export interface ParsedAddress {
  streetAddress: string;
  suburb: string;
  postcode: string;
}

export function parseAddress(fullAddress: string): ParsedAddress {
  if (!fullAddress) {
    return { streetAddress: '', suburb: '', postcode: '' };
  }
  let streetAddress = fullAddress;
  let suburb = '';
  let postcode = '';

  const commaIdx = fullAddress.indexOf(',');
  if (commaIdx !== -1) {
    streetAddress = fullAddress.substring(0, commaIdx).trim();
    const rest = fullAddress.substring(commaIdx + 1).trim();

    // Extract suburb and postcode
    const match = rest.match(/^(.*?)[, ]+([A-Z]{2,3})\s+(\d{4})$/);
    if (match) {
      suburb = match[1].trim();
      postcode = match[3].trim();
    } else {
      suburb = rest.split(',')[0].trim();
    }
  }
  return { streetAddress, suburb, postcode };
}
